import { Component } from "@angular/core";

/**
 * The background of the screens before login - login, forgot password and
 * reset password - in the menu's language (#173): big, opaque shapes in the
 * house colours overlapping in two opposite corners of a perzik ground, the
 * card in between.
 */
@Component({
    selector: "app-vormen",
    standalone: true,
    templateUrl: "./vormen.component.html",
    styleUrls: ["./vormen.component.css"],
})
export class VormenComponent {}
